import PropertyTypeListPage from "../components/home/components/propertytypes/PropertyTypeListPage";
import Layout from "../components/layouts/allpagelayout";

export default function PropertyTypePage() {
  return (
    <Layout>
      <PropertyTypeListPage />
    </Layout>
  );
}